<main class="card home-page text-gray-800 dark:text-gray-100">
  <header class="home-header">
    <div class="flex items-start gap-3">
      <span class="home-header-icon" aria-hidden="true">
        <i class="pi pi-home"></i>
      </span>
      <div>
        <p class="text-sm uppercase tracking-[0.18em] text-blue-600 dark:text-blue-400 font-semibold mb-1">Mobydyg Admin Manager</p>
        <h1 class="text-3xl md:text-4xl font-light text-gray-800 dark:text-gray-100">Panel administrativo</h1>
        <p class="text-base text-gray-600 dark:text-gray-300 font-normal max-w-3xl mt-2">
          Administra comercios, agentes, planes y operaciones desde un solo lugar.
        </p>
      </div>
    </div>
  </header>

  <section aria-labelledby="main-access-title">
    <div class="flex items-center justify-between gap-4 mb-4">
      <div>
        <h2 id="main-access-title" class="home-section-title">Accesos principales</h2>
        <p class="home-section-subtitle">Ingresa directamente a las herramientas de administración.</p>
      </div>
    </div>

    <div class="home-access-grid">
      <a
        *ngFor="let item of accessItems"
        [routerLink]="item.route"
        class="home-access-card bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm"
        [attr.aria-label]="'Ir a ' + item.label">
        <span class="home-access-icon" aria-hidden="true">
          <i [class]="item.icon"></i>
        </span>
        <span class="home-access-content">
          <span class="home-access-title">{{ item.label }}</span>
          <span class="home-access-description">{{ item.description }}</span>
        </span>
        <i class="pi pi-arrow-right home-access-arrow" aria-hidden="true"></i>
      </a>
    </div>
  </section>
</main>
